import { render, staticRenderFns } from "./ScrapView.vue?vue&type=template&id=d09ec616&scoped=true"
import script from "./ScrapView.vue?vue&type=script&lang=js"
export * from "./ScrapView.vue?vue&type=script&lang=js"
import style0 from "./ScrapView.vue?vue&type=style&index=0&id=d09ec616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09ec616",
  null
  
)

export default component.exports